<template>
    <div>
        <div class="row row-cols-1 row-cols-sm-auto mb-2">
            <div class="d-flex flex-column">
                <label class="text-14 mb-1" for="shipping_forename">First name</label>
                <Popper :content="errors.shipping_forename" arrow placement="top" class="w-100 m-0 border-0" :show="!!errors.shipping_forename">
                    <Field id="shipping_forename" name="shipping_forename" type="text" placeholder="First Name" class="form-control" :class="{'error': errors.shipping_forename}"/>
                </Popper>
            </div>
            <div class="d-flex flex-column">
                <label class="text-14 mb-1" for="shipping_surname">Last name</label>
                <Popper :content="errors.shipping_surname" arrow placement="top" class="w-100 m-0 border-0" :show="!!errors.shipping_surname">
                    <Field id="shipping_surname" name="shipping_surname" type="text" placeholder="Last Name" class="form-control" :class="{'error': errors.shipping_surname}"/>
                </Popper>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-auto mb-2">
            <div class="d-flex flex-column">
                <label class="text-14 mb-1" for="shipping_postcode">Postcode</label>
                <Popper :content="errors.shipping_postcode" arrow placement="top" class="w-100 m-0 border-0" :show="!!errors.shipping_postcode">
                    <Field id="shipping_postcode" name="shipping_postcode" type="text" placeholder="Postcode" class="form-control" @keyup="this.$parent.$parent.$parent.postcodeLookup($event.target.value, false)" :class="{'error': errors.shipping_postcode}"/>
                </Popper>
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-auto align-items-center mb-2">
            <div class="d-flex flex-column">
                <label class="text-14 mb-1" for="shipping_address">Address</label>
                <Popper :content="errors.shipping_address" arrow placement="top" class="w-100 m-0 border-0" :show="!!errors.shipping_address">
                    <Field v-slot="{ value }" id="shipping_address" name="shipping_address" as="select" class="form-select" :class="{'error': errors.shipping_address}">
                        <option value="" disabled>Please select your address</option>
                        <template v-for="address, key in addresses">
                            <template v-if="key != 0">
                                <option :key="key" :value="key" :selected="value && value.includes(address)">{{ address }}</option>
                            </template>
                        </template>
                    </Field>
                </Popper>
            </div>
            <div class="d-flex flex-column">
                <label for="input_shipping_address_manually" class="d-inline-block cursor-pointer mt-2">
                    <span class="text-secondary fw-bold" @click="this.$emit('inputShippingAddressManually')">Enter address manually?</span>
                    <Field type="checkbox" id="input_shipping_address_manually" name="input_shipping_address_manually" class="d-none" :value="true" v-model="inputShippingAddressManually"/>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12" v-if="inputShippingAddressManually == true">
                <div class="row row-cols-1 row-cols-sm-auto">
                    <div class="d-flex flex-column">
                        <label class="text-14 mb-1" for="shipping_address1">Address 1</label>
                        <Popper :content="errors.shipping_address1" arrow placement="top" class="w-100 m-0 border-0" :show="!!errors.shipping_address1">
                            <Field id="shipping_address1" name="shipping_address1" type="text" placeholder="Address 1" class="form-control" :class="{'error': errors.shipping_address1}"/>
                        </Popper>
                    </div>
                    <div class="d-flex flex-column">
                        <label class="text-14 mb-1" for="shipping_address2">Address 2</label>
                        <Field id="shipping_address2" name="shipping_address2" type="text" placeholder="Address 2" class="form-control"/>
                    </div>
                </div>
                <div class="row row-cols-1 row-cols-sm-auto my-2">
                    <div class="d-flex flex-column">
                        <label class="text-14 mb-1" for="shipping_address3">Address 3</label>
                        <Field id="shipping_address3" name="shipping_address3" type="text" placeholder="Address 3" class="form-control" />
                    </div>
                    <div class="d-flex flex-column">
                        <label class="text-14 mb-1" for="shipping_town">Town</label>
                        <Popper :content="errors.shipping_town" arrow placement="top" class="w-100 m-0 border-0" :show="!!errors.shipping_town">
                            <Field id="shipping_town" name="shipping_town" type="text" placeholder="Town" class="form-control" :class="{'error': errors.shipping_town}"/>
                        </Popper>
                    </div>
                </div>
                <div class="row row-cols-1 row-cols-sm-auto">
                    <div class="d-flex flex-column">
                        <label class="text-14 mb-1" for="shipping_county">County</label>
                        <Field id="shipping_county" name="shipping_county" type="text" placeholder="County" class="form-control" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    export default {
        props: ['sessionPostcode', 'addresses', 'errors'],
        components: { Field, ErrorMessage },
        data() {
            return {
                inputShippingAddressManually: false
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
<style lang="scss" scoped>
    .form-select {
        @media screen and (min-width: 576px) and (max-width: 767px) {
            width: 177px;
        }
    }
    .row-cols-sm-auto {
        .form-control, .form-select {
            @media screen and (min-width: 768px) {
                width: 280px;
            }
        }
    }
</style>